<script>
  import { closeModal } from "svelte-modals";

  export let languages = [];
  export let selectedLanguage;
  export let onSelect;

  function selectLanguage(lang) {
    onSelect(lang); // Call the provided function and close the modal
    closeModal()
  }

  function handleOptionKeydown(event, lang) {
    if (event.key === 'Enter' || event.key === ' ') {
      selectLanguage(lang);
    }
  }
</script>

<div class="modal" role="dialog">
  <div class="modal-content">
    <div>
      {#each languages as lang}
        <div class="language-option"
             on:click={() => selectLanguage(lang.code)}
             on:keydown={(e) => handleOptionKeydown(e, lang.code)}
             tabindex="0"
             role="option"
             aria-selected={$selectedLanguage === lang.code}>
          {lang.name}
        </div>
      {/each}
    </div>
  </div>
</div>

<style>
  .language-option {
    padding: 10px;
    cursor: pointer;
    color: #333333;
    white-space: nowrap;
  }

  .language-option:hover {
    background-color: #f0f0f0;
  }
</style>